import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccessQuestionRoutingModule } from './access-question-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { AccessQuestionComponent } from './access-question/access-question.component';
import { QuestionRowComponent } from './question-row/question-row.component';


@NgModule({
  declarations: [
    AccessQuestionComponent,
    QuestionRowComponent
  ],
  imports: [
    CommonModule,
    AccessQuestionRoutingModule,
    FormsModule,
    SharedModule,
    RouterModule,
    NgxSpinnerModule,
    TranslateModule,
  ]
})
export class AccessQuestionModule { }
